<template>
	<div class="header___1RxdU" :class="{'isScroll___1Pl15':type==2||showSubmenu}">
		<div class="navbar navbar-expand-lg">
			<a class="navbar-brand" href="/home">
				<img v-show="type==1&&!showSubmenu" src="@/assets/img/common/logo.png" alt="Logo">
				<img v-show="type==2||showSubmenu" src="@/assets/img/common/logo2.png" alt="Logo">
			</a>
			<div class="navbar-toggler" :class="{'active':isOpenColumnNab}" @click="openColumnNav">
				<span class="iconfont " :class="{'icon-fenlei':!isOpenColumnNab,'icon-fork':isOpenColumnNab}"></span>
			</div>

			<div class="right___2gZlz collapse navbar-collapse" :class="{'show':isOpenColumnNab}" id="header-box">
				<nav id="header-box-nav" class="header-box-nav___2omzp">
					<ul id="nav" class="navbar-nav ml-auto">
						<li class="nav-item" :class="{'active':nowIndex=='/home'}">
							<a class="page-scroll" :href="type==1?'#home':'/home'">首页</a>
						</li>
						<li class="nav-item" :class="{'active':nowIndex=='/product','submenu':showSubmenu}" @mouseover="mouseHandle(1)" @mouseout="mouseHandle(2)">
							<a class="page-scroll" href="#product"	@click.capture.prevent.stop="openSubMenu">产品中心
								<i class="iconfont "
									:class="{'icon-xiajiantou': !showSubmenu,'icon-shangjiantou': showSubmenu}"></i>
							</a>
							<div class="content___25dVu">
								<div class="content-menu___3Glr0">
									<ul>
										<li v-for="(item,index) in productList" :key="index"><a
												class="link___c01hW content-menu-link___26fdv"
												:href="'/product?id=' + item.id">{{item.title}}
												<i class="arr-icon el-icon-arrow-right"></i></a></li>
									</ul>
								</div>
							</div>
						</li>
						<li class="nav-item" :class="{'active':nowIndex=='/solution'}">
							<a class="page-scroll" href="/solution">解决方案</a>
						</li>
						<li class="nav-item" :class="{'active':nowIndex=='/case'}">
							<a class="page-scroll" href="/case">行业案例</a>
						</li>
						<li class="nav-item" :class="{'active':nowIndex=='/contact'}">
							<a class="page-scroll" href="/contact">联系我们</a>
						</li>
					</ul>
				</nav>

			</div>

		</div>

	</div>

</template>

<script>
	export default {
		name: "NavBar",
		props: ['type'],
		data() {
			return {
				isOpenColumnNab: false,
				productList: [{
						id: 0,
						title: '智慧食堂',
					},
					{
						id: 1,
						title: '智慧考勤',
					},
					{
						id: 2,
						title: '智慧宿舍',
					},
					{
						id: 3,
						title: '智慧门禁',
					},
					{
						id: 4,
						title: '边界预警',
					},
					{
						id: 5,
						title: '互联网+明厨亮灶',
					},
					{
						id: 6,
						title: '区域综合平台',
					},
					{
						id: 7,
						title: '家校视讯通话',
					}
				],
				showSubmenu: false, //是否显示子菜单

				isMobile: false, // 是否移动端显示
			}

		},
		computed: {
			nowIndex() {
				let val = this.$route.fullPath;
				console.log(val);
				if (val.indexOf('/home') != -1) {
					return '/home';
				} else if (val.indexOf('/product') != -1) {
					return '/product';
				} else if (val.indexOf('/solution') != -1) {
					return '/solution';
				} else if (val.indexOf('/case') != -1) {
					return '/case';
				} else if (val.indexOf('/contact') != -1) {
					return '/contact';
				}
			}
		},
		mounted() {
			if(window.innerWidth < 470){
				this.isMobile = true;
			}
		},
		methods: {
			//鼠标经过绑定事件和点击事件阻止冒泡
			mouseHandle(flag){
				if(!this.isMobile){
					if(flag == 1 ){
						this.showSubmenu = true;
					}else{
						this.showSubmenu = false;
					}
				}
			},
			
			openColumnNav() {
				this.isOpenColumnNab = !this.isOpenColumnNab;
			},
			openSubMenu() {
				this.showSubmenu = !this.showSubmenu;
			}
		}
	}
</script>

<style scoped>
	.header___1RxdU {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		width: 100%;
		height: 80px;
		overflow: visible;
		font-size: 0;
		/* background-color: #fff; */
		transition: all .3s cubic-bezier(.645, .045, .355, 1);
		will-change: transforml;
	}

	.header___1RxdU.isScroll___1Pl15 {
		background-color: #fff;
		box-shadow: 0 8px 24px 0 rgba(0, 79, 213, .05);
	}

	.nav-item .content___25dVu:after {
		background-color: rgba(247, 248, 250, 1);
	}

	.isScroll___1Pl15 .nav-item .content___25dVu:after {
		background-color: rgba(247, 248, 250, 1);
	}

	.slideDown___3d3C_ {
		transform: translateY(0);
		transition: transform .4s ease-out;
	}

	.right___2gZlz {
		position: relative;
		display: -ms-flexbox;
		display: flex;
		z-index: 2;
	}

	.header-box-nav___2omzp {
		flex: 100% 1 1;
		height: 80px;
	}

	.navbar {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: justify;
		justify-content: space-between;
		max-width: 1200px;
		height: 100%;
		margin: 0 auto;
	}

	.navbar-brand {
		padding: 0
	}

	.navbar-brand img {
		display: inline-block;
		max-width: 104px;
		border: none;
	}

	.navbar-toggler {
		padding: 0;
		margin-right: 20px;
		cursor: pointer;
		border: none;
	}

	.navbar-toggler .iconfont {
		font-size: 38px;
		color: #fff;
	}

	.isScroll___1Pl15 .navbar-toggler .iconfont {
		font-size: 38px;
		color: #333333;
	}

	.navbar-toggler .toggler-icon {
		width: 30px;
		height: 2px;
		background-color: #fff;
		display: block;
		margin: 5px 0;
		position: relative;
		-webkit-transition: all .3s ease-out 0s;
		-moz-transition: all .3s ease-out 0s;
		-ms-transition: all .3s ease-out 0s;
		-o-transition: all .3s ease-out 0s;
		transition: all .3s ease-out 0s
	}

	.isScroll___1Pl15 .navbar-toggler .toggler-icon {
		background-color: #333;
	}

	.navbar-toggler.active .toggler-icon:nth-of-type(1) {
		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: rotate(45deg);
		top: 7px
	}

	.navbar-toggler.active .toggler-icon:nth-of-type(2) {
		opacity: 0
	}

	.navbar-toggler.active .toggler-icon:nth-of-type(3) {
		-webkit-transform: rotate(135deg);
		-moz-transform: rotate(135deg);
		-ms-transform: rotate(135deg);
		-o-transform: rotate(135deg);
		transform: rotate(135deg);
		top: -7px
	}

	.collapse:not(.show) {
		display: none;
	}

	.navbar-nav .nav-item {
		/* position: relative;
 	margin-left: 40px; */
		/* display: inline-block;
	height: 100%;
	padding-right: 28px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none; */

		position: relative;
		display: inline-block;
		padding: 28px;
		color: #333;
		font-weight: 500;
		font-size: 16px;
		font-family: AlibabaPuHuiTiRegular;
		letter-spacing: 0;
		cursor: pointer;
		transition: all .3s cubic-bezier(.645, .045, .355, 1);
		line-height: 24px;
	}

	.navbar-expand-lg .navbar-nav {
		flex-direction: row;
		justify-content: flex-end;
	}

	.navbar-nav .nav-item>a {
		font-size: 16px;
		font-weight: 400;
		color: #fff;
		-webkit-transition: all .3s ease-out 0s;
		-moz-transition: all .3s ease-out 0s;
		-ms-transition: all .3s ease-out 0s;
		-o-transition: all .3s ease-out 0s;
		transition: all .3s ease-out 0s;
		padding: 10px 0;
		position: relative;
		text-decoration: none;
	}

	.isScroll___1Pl15 .navbar-nav .nav-item>a {
		color: #333;
	}

	.navbar-nav .nav-item::before {
		/* position: absolute;
 	content: '';
 	bottom: 0;
 	left: 0;
 	width: 0;
 	height: 3px;
 	background-color: #ffb316;
 	-webkit-transition: all .3s ease-out 0s;
 	-moz-transition: all .3s ease-out 0s;
 	-ms-transition: all .3s ease-out 0s;
 	-o-transition: all .3s ease-out 0s;
 	transition: all .3s ease-out 0s; */
		position: absolute;
		top: 0;
		left: 50%;
		width: calc(100% - 56px);
		height: 4px;
		background-color: #ffb316;
		border-radius: 0 0 100px 100px;
		transform: translate(-50%) scaleX(0);
		opacity: 0;
		transition: all .6s cubic-bezier(.165, .84, .44, 1);
		content: "";

	}


	.navbar-nav .nav-item.active::before,
	.navbar-nav .nav-item:hover::before {
		/* width: 100%; */
		position: absolute;
		top: 0;
		left: 50%;
		width: calc(100% - 56px);
		height: 4px;
		background-color: #ffb316;
		border-radius: 0 0 100px 100px;
		transform: translate(-50%) scaleX(0);
		opacity: 0;
		transition: all .6s cubic-bezier(.165, .84, .44, 1);
		content: "";

		transform: translate(-50%) scaleX(1);
		opacity: 1;
	}

	.navbar-nav .nav-item:hover .sub-menu {
		top: 100%;
		opacity: 1;
		visibility: visible
	}


	.navbar-nav .nav-item .sub-menu {
		width: 200px;
		background-color: #fff;
		-webkit-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
		box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
		position: absolute;
		top: 110%;
		left: 0;
		opacity: 0;
		visibility: hidden;
		-webkit-transition: all .3s ease-out 0s;
		-moz-transition: all .3s ease-out 0s;
		-ms-transition: all .3s ease-out 0s;
		-o-transition: all .3s ease-out 0s;
		transition: all .3s ease-out 0s
	}


	.navbar-nav .nav-item .sub-menu li {
		display: block
	}

	.navbar-nav .nav-item .sub-menu li a {
		display: block;
		padding: 8px 20px;
		color: #222
	}

	.navbar-nav .nav-item .sub-menu li a.active,
	.navbar-nav .nav-item .sub-menu li a:hover {
		padding-left: 25px;
		color: #1677ff;
	}

	.navbar-nav .sub-nav-toggler {
		display: none
	}

	.nav-item.submenu .content___25dVu {
		height: auto;
		opacity: 1;
		animation: menuShow___meeuU .2s ease-out 1;
		animation-fill-mode: both;
		pointer-events: auto
	}
	
	.navbar-nav .sub-nav-toggler span {
		width: 8px;
		height: 8px;
		border-left: 1px solid #222;
		border-bottom: 1px solid #222;
		-webkit-transform: rotate(-45deg);
		-moz-transform: rotate(-45deg);
		-ms-transform: rotate(-45deg);
		-o-transform: rotate(-45deg);
		transform: rotate(-45deg);
		position: relative;
		top: -5px
	}
	
	
	/* .nav-item.active .content___25dVu */
	.nav-item:hover .content___25dVu,
		{
		margin-top: 0;
		height: auto;
		opacity: 1;
		animation: menuShow___meeuU .2s ease-out 1;
		animation-fill-mode: both;
		pointer-events: auto
	}
	
	/* ,.nav-item.active .content___25dVu li */
	.nav-item:hover .content___25dVu li {
		opacity: 1;
	}
	
	.nav-item .content___25dVu {
		position: absolute;
		top: 80px;
		left: 0;
		display: block;
		width: 100%;
		height: 0;
		padding: 32px 0 32px;
		opacity: 0;
		transition: all .6s cubic-bezier(.165, .84, .44, 1);
		animation: menuHide___2PsZa .2s ease-out 1;
		animation-fill-mode: both;
		pointer-events: none;
		will-change: transform, opacity, height
	}
	
	.nav-item .content___25dVu:after {
		position: absolute;
		top: 0;
		left: -100vw;
		width: 300vw;
		height: 100%;
		/* background-color: rgba(247, 248, 250, 1); */
		transform-origin: 50% 0;
		content: ""
	}
	
	@keyframes menuShow___meeuU {
		0% {
			-webkit-transform: translateY(-30px);
			opacity: 0
		}
	
		to {
			-webkit-transform: translate(0);
			opacity: 1
		}
	}
	
	@keyframes menuHide___2PsZa {
		0% {
			-webkit-transform: translate(0);
			opacity: 1
		}
	
		to {
			-webkit-transform: translateY(-30px);
			opacity: 0
		}
	}
	
	.content-menu___3Glr0 {
		position: relative;
		top: 0;
		z-index: 1;
		display: -ms-flexbox;
		display: flex;
		width: 350px;
		/* min-width: 38vw; */
		padding-left: 28px;
		white-space: nowrap;
	}
	
	.content-menu___3Glr0 ul {
		padding-left: 0;
	}
	
	.content-menu___3Glr0 ul li {
		float: left;
		width: 124px;
	}
	
	.content-menu___3Glr0 ul li a {
		color: #333;
		margin: 15px 5px;
		text-decoration: none;
	}
	
	
	.link___c01hW {
		color: #333;
	}
	
	.content-menu-link___26fdv {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-align: center;
		align-items: center;
		color: #666;
		font-weight: 400;
		font-size: 16px;
		line-height: 24px
	}
	
	.content-menu-link___26fdv .arr-icon {
		margin-left: 6px;
		color: #ffb316;
		font-size: 12px;
		transform: rotate(0deg) scale(.5);
		opacity: 0
	}
	
	.content-menu-link___26fdv,
	.content-menu-link___26fdv .arr-icon {
		transition: all .3s linear
	}
	
	.content-menu-link___26fdv:hover {
		color: #ffb316;
		/* text-shadow: rgba(0,0,0,0.3) 0 0 2px; */
	}
	
	.content-menu-link___26fdv:hover .arr-icon {
		transform: rotate(0deg) scale(1);
		opacity: 1
	}
</style>
<style scoped>
	@media only screen and (min-width:992px) and (max-width:1199px) {
		.navbar-nav .nav-item {
			margin-left: 30px
		}

		.navbar-expand-lg .navbar-nav {
			flex-direction: row;
			justify-content: flex-start;
		}
	}

	@media (max-width:767px) {
		.navbar-nav .nav-item {
			margin: 0
		}

		.navbar-nav .nav-item a::before {
			display: none
		}

		.navbar-nav .nav-item a {
			display: block;
			padding: 4px 0;
			color: #222
		}

		.navbar-nav .nav-item:hover .sub-menu {
			top: 0
		}

		.navbar-nav .nav-item .sub-menu {
			position: relative;
			width: 100%;
			top: 0;
			display: none;
			opacity: 1;
			visibility: visible
		}

		.navbar-nav .sub-nav-toggler {
			display: block;
			position: absolute;
			right: 0;
			top: 0;
			background: none;
			color: #222;
			font-size: 18px;
			border: 0;
			width: 30px;
			height: 30px
		}

		.navbar-collapse {
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			background-color: #fff;
			z-index: 9;
			-webkit-box-shadow: 0 15px 20px 0 rgba(0, 0, 0, .1);
			-moz-box-shadow: 0 15px 20px 0 rgba(0, 0, 0, .1);
			box-shadow: 0 15px 20px 0 rgba(0, 0, 0, .1);
			padding: 5px 12px
		}

		.navbar-nav {
			display: flex;
			flex-direction: column !important;
			padding-left: 0;
			margin-bottom: 0;
			list-style: none;
		}

		.header-box-nav___2omzp {
			height: auto;
		}

		.navbar-nav .nav-item.active::before,
		.navbar-nav .nav-item:hover::before {
			display: none;
		}

		.navbar-nav .nav-item.active a,
		.navbar-nav .nav-item:hover a {
			color: #ffb316;
		}

		.navbar-nav .nav-item a.link___c01hW {
			color: #333;
		}

		/* .navbar-nav .nav-item.active .content___25dVu, */
		.navbar-nav .nav-item:hover .content___25dVu {
			position: relative;
			top: 0;
			padding: 0 0 0 32px;
			margin-top: 10px;
		}

		.navbar-nav .nav-item {
			padding-bottom: 0;
			padding: 10px;
		}

	}

	@media only screen and (min-width:768px) and (max-width:991px) {
		.navbar-nav .nav-item a {
			display: block;
			padding: 4px 0;
			color: #222
		}

		.navbar-nav .nav-item a::before {
			display: none
		}

		.navbar-nav .nav-item:hover .sub-menu {
			top: 0
		}

		.navbar-nav .nav-item .sub-menu {
			position: relative;
			width: 100%;
			top: 0;
			display: none;
			opacity: 1;
			visibility: visible
		}

		.navbar-nav .sub-nav-toggler {
			display: block;
			position: absolute;
			right: 0;
			top: 0;
			background: none;
			color: #222;
			font-size: 18px;
			border: 0;
			width: 30px;
			height: 30px
		}

		.navbar-collapse {
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			background-color: #fff;
			z-index: 9;
			-webkit-box-shadow: 0 15px 20px 0 rgba(0, 0, 0, .1);
			-moz-box-shadow: 0 15px 20px 0 rgba(0, 0, 0, .1);
			box-shadow: 0 15px 20px 0 rgba(0, 0, 0, .1);
			padding: 5px 12px;
		}

		.navbar-nav {
			display: -ms-flexbox;
			display: flex;
			-ms-flex-direction: column;
			flex-direction: column !important;
			padding-left: 0;
			margin-bottom: 0;
			list-style: none;
		}

		.header-box-nav___2omzp {
			height: auto;
		}

		.navbar-nav .nav-item.active::before,
		.navbar-nav .nav-item:hover::before {
			display: none;
		}

		.navbar-nav .nav-item.active a,
		.navbar-nav .nav-item:hover a {
			color: #ffb316;
		}

		.navbar-nav .nav-item a.link___c01hW {
			color: #333;
		}

		/* .navbar-nav .nav-item.active .content___25dVu, */
		.navbar-nav .nav-item:hover .content___25dVu {
			position: relative;
			top: 0;
			padding: 0 0 0 32px;
			margin-top: 10px;
		}

		.navbar-nav .nav-item {
			padding-bottom: 0;
			padding: 10px;
		}
	}


</style>
<style scoped>
	@media only screen and (min-width:992px) and (max-width:1199px) {
		.navbar-brand {
			margin-left: 20px;
		}
	}

	@media only screen and (min-width:768px) and (max-width:991px) {
		.navbar-brand {
			margin-left: 20px;
		}
	}

	@media (max-width:767px) {
		.navbar-brand {
			margin-left: 20px;
		}

		.home-swiper /deep/ .indicator {
			bottom: 270px;
		}

		.navbar-nav .nav-item {
			border-bottom: 1px solid rgba(126, 134, 142, 0.24);
		}

		.navbar-nav .nav-item:last-child {
			border-bottom: none;
		}

		.content-menu___3Glr0 ul li a {
			margin: 5px 5px;
		}

		.content-menu___3Glr0 {
			width: auto;
			height: 0;
			opacity: 0;
			padding: 15px 0;
		}

		.navbar-nav .nav-item a.page-scroll {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}

		.content___25dVu {
			height: 0;
			opacity: 0;
		}

		/* ,.navbar-nav .nav-item.active .content___25dVu */
		.navbar-nav .nav-item:hover .content___25dVu {
			height: 0;
			opacity: 0;
			margin: 0;
		}

		.submenu .content___25dVu {
			height: auto;
			opacity: 1;
		}

		.nav-item.submenu:hover .content___25dVu,
		.nav-item.submenu.active .content___25dVu {
			height: auto;
			opacity: 1;
		}

		.submenu .content-menu___3Glr0 {
			height: auto;
			opacity: 1;
		}

		.isScroll___1Pl15 .nav-item .content___25dVu:after {
			background-color: #fff;
		}
	}
</style>
